import { Component, OnInit, OnDestroy, Input, HostBinding } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { DialogService } from '../../services/dialog-service/dialog-service.service';

@Component({
    selector: 'app-agb',
    templateUrl: './agb.component.html',
    styleUrls: ['./agb.component.scss'],
    standalone: false
})
export class AgbComponent implements OnInit, OnDestroy {
    @Input() mode: 'page' | 'dialog' = 'page';

    @HostBinding('class.dialog-mode')
        get isDialog(): boolean {
        return this.mode === 'dialog';
    }

    constructor(
        private headerService: HeaderServiceService,
        private dialogService: DialogService
    ) {
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
    }

    showPrivacy() {
        this.dialogService.openPrivacyDialogInform('Schließen');
    }

    ngOnInit(): void {
        this.headerService.loadHeaderText('AGB');
        document.body.scrollTop = 0;
    }

    ngOnDestroy(): void {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }

    openContactDialog(){
        this.dialogService.openListingRequestDialog();
    }
}
